import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Protected({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-white/60">Shuffling…</div>
      </div>
    );
  }
  if (!user && !location.state?.user) {
    return <Navigate to="/" replace />;
  }
  return children;
}
